import { FC, useCallback } from 'react';
import * as Dialog from '@radix-ui/react-dialog';
import { Button } from '@features/ui';
import { CloseIcon } from '@features/ui/icons';
import {
  BalanceStackedData,
  PaAccounts,
  StackedData,
  TPayout,
} from '@src/types';
import { AccountPABarActive } from '@features/admin/payoutRequests';

interface AccountPAStatsDialogProps {
  open: boolean;
  payoutSelected: TPayout | null;
  paAccounts: PaAccounts | null;
  onOpenChange: (open: boolean) => void;
  dailyTradeVolumesAndContracts: StackedData[];
  dailyProfitLossAndBalance: BalanceStackedData[];
}
export const AccountPAStatsDialog: FC<AccountPAStatsDialogProps> = ({
  open,
  onOpenChange,
  ...props
}) => {
  const handleClose = useCallback(() => {
    onOpenChange(false);
  }, [onOpenChange]);

  return (
    <Dialog.Root open={open}>
      <Dialog.Portal>
        <Dialog.Overlay
          className="data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 fixed inset-0 z-50 bg-black/80"
          data-slot="sheet-overlay"
        />
        <Dialog.Content className="fixed left-1/2 top-1/2 max-h-[85vh] lg:w-[805px] w-[80%]  -translate-x-1/2 -translate-y-1/2 rounded-md bg-[#414141] pt-[78px] pb-3 px-[50px] shadow-[var(--shadow-6)] focus:outline-none data-[state=open]:animate-contentShow z-50">
          <Dialog.Close asChild>
            <Button
              aria-label="Close"
              className="[&_svg]:!size-auto absolute right-[33px] top-[42px] inline-flex size-[25px] appearance-none items-center justify-center rounded-full"
              variant={'ghost'}
              onClick={() => onOpenChange(false)}
            >
              <CloseIcon />
            </Button>
          </Dialog.Close>
          <div className="overflow-auto max-h-[calc(85vh-100px)]">
            <AccountPABarActive onClose={handleClose} {...props} />
          </div>
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  );
};
